import React, { useContext } from "react";

import SlackChannelField from "components/event/edit/SlackChannelField";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";

const DetailsSlackChannel: React.FC<{}> = () => {
  const { changeSelectedChannel, selectedChannel } = useContext(StoryModalContext);

  return (
    <SlackChannelField
      className="modal-footer-column"
      imageIconPath="/slack.png"
      showLabel={false}
      onSelectedChannel={changeSelectedChannel}
      channel={selectedChannel}
      page="stories"
    />
  );
};

export default DetailsSlackChannel;
